import { CoolingEfficiencyVariables as Vars, CoolingEfficiencyNorms } from 'sigma-mappings';

const HIGH_ID = '5e2fedc4-b877-4ec2-bc3b-d0875116b65c';
const VERY_HIGH_ID = '183abd19-5fd8-426a-8288-db942248caf3';
const NEGATIVE_HIGH_ID = 'c3e8e9f8-82cd-4624-8c77-52658a399b86';
const NEGATIVE_VERY_HIGH_ID = '5dbcd937-e01a-42c2-acf5-15b4fbae67d8';

// Ids de Tipo de Dados por Norma para o gráfico, constantes na API.
const coolingEfficiencyGraphicIds = {
  [CoolingEfficiencyNorms.IEC_60076_7]: {
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_HIGH]: HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_VERY_HIGH]: VERY_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_HIGH]: NEGATIVE_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_VERY_HIGH]: NEGATIVE_VERY_HIGH_ID,
    [Vars.CALCULATED_EXPONENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: 'efacf807-8310-436b-9e2b-85ec501fd165',
    [Vars.CALCULATED_DIFFERENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: '707d233f-9ddc-4652-b22e-02da38080b53',
  },
  [CoolingEfficiencyNorms.IEEE_C57_91]: {
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_HIGH]: HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_VERY_HIGH]: VERY_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_HIGH]: NEGATIVE_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_VERY_HIGH]: NEGATIVE_VERY_HIGH_ID,
    [Vars.CALCULATED_EXPONENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: '3c4aa1f0-f772-4153-a4ce-8fd9d5a97e2c',
    [Vars.CALCULATED_DIFFERENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: null,
  },
  [CoolingEfficiencyNorms.NBR_5356_7]: {
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_HIGH]: HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_VERY_HIGH]: VERY_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_HIGH]: NEGATIVE_HIGH_ID,
    [Vars.PARAMETERIZED_MAXIMUM_ALLOWABLE_DIFFERENCE_NEGATIVE_VERY_HIGH]: NEGATIVE_VERY_HIGH_ID,
    [Vars.CALCULATED_EXPONENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: '78d172fd-b125-4bf2-8d67-c770c996c674',
    [Vars.CALCULATED_DIFFERENTIAL_MEASURED_OIL_TEMPERATURE_DIFFERENCE]: 'f4cc85e0-3470-4724-859b-d175df70b85c',
  },
};

export default coolingEfficiencyGraphicIds;
